// src/Services/fetchUpdateEmpleado.js
import { USERS } from "../Constants/Endpoinst";
import { ApiRequestInterceptor } from "./apiRequest";

/**
 * @param {string|number} numeroEmpleado - Llave primaria del empleado
 * @param {object} body - Datos a actualizar
 * @param {string} token - JWT de autorización
 */
export const fetchUpdateEmpleado = async (numeroEmpleado, body, token) => {
    const method = "PUT";
    const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
    };
    const url = `${USERS.updateEmpleado}/${numeroEmpleado}`;

    const response = await ApiRequestInterceptor(url, method, body, headers);

    const status = response.code;
    if (status >= 200 && status < 300 && response.data?.message) {
        return response.data;
    }
    throw new Error(response?.data?.error || "Error desconocido");
};
